import React from "react";
import type {
  IUserAssignPreview,
  IUserAssignPreviewRow,
} from "src/Interfaces/portfolioGroups";

interface IProps {
  preview: IUserAssignPreview;
}

const PreviewTable: React.FC<{
  title: string;
  rows: IUserAssignPreviewRow[];
}> = ({ title, rows }) => (
  <div className="w-full flex flex-col gap-2">
    <div className="text-sm font-bold">{title}</div>
    <div className="max-h-48 overflow-auto border border-sky-100 rounded">
      <table className="w-full border-collapse text-xs">
        <thead>
          <tr className="bg-gray-50">
            <th className="border border-sky-100 py-2 px-2 whitespace-nowrap">
              #
            </th>
            <th className="border border-sky-100 py-2 px-2 whitespace-nowrap">
              اکانت
            </th>
            <th className="border border-sky-100 py-2 px-2 whitespace-nowrap">
              گروه قبلی
            </th>
            <th className="border border-sky-100 py-2 px-2 whitespace-nowrap">
              گروه بعدی
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.length ? (
            rows.map((row, index) => (
              <tr key={row.sahraUserId}>
                <td className="border border-sky-100 py-2 px-2 text-center">
                  {index + 1}
                </td>
                <td className="border border-sky-100 py-2 px-2 text-center">
                  {row.accountName}
                </td>
                <td className="border border-sky-100 py-2 px-2 text-center">
                  {row.currentGroupName}
                </td>
                <td className="border border-sky-100 py-2 px-2 text-center">
                  {row.nextGroupName}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                className="border border-sky-100 py-3 px-2 text-center text-gray-400"
                colSpan={4}
              >
                موردی وجود ندارد
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

const AssignmentPreviewTables: React.FC<IProps> = ({ preview }) => (
  <div className="w-full flex flex-col gap-4">
    {(preview.withGroup || []).length > 0 && (
      <PreviewTable title="با گروه" rows={preview.withGroup} />
    )}
    {(preview.withoutGroup || []).length > 0 && (
      <PreviewTable title="بدون گروه" rows={preview.withoutGroup} />
    )}
  </div>
);

export default AssignmentPreviewTables;
